/**
 * Feature Flags Configuration for Dashboard
 * This file controls which features are enabled/disabled in the admin dashboard
 */

const features = {
  // Admin Approval Feature
  // When enabled: Shows pending users/products pages in sidebar and navigation
  // When disabled: Hides all admin approval related UI components and routes
  ADMIN_APPROVAL: process.env.REACT_APP_FEATURE_ADMIN_APPROVAL !== 'false', // Default enabled unless explicitly set to 'false'
  
  // Email Verification Feature
  EMAIL_VERIFICATION: process.env.REACT_APP_FEATURE_EMAIL_VERIFICATION !== 'false', // Default enabled unless explicitly set to 'false'
  
  // Social Login Features - Always enabled
  SOCIAL_LOGIN_GOOGLE: true,
  SOCIAL_LOGIN_FACEBOOK: true,
  SOCIAL_LOGIN_TWITTER: true,
  
  // Payment Features
  PAYMENTS: process.env.REACT_APP_FEATURE_PAYMENTS !== 'false',
  
  // Chat Feature
  CHAT: process.env.REACT_APP_FEATURE_CHAT !== 'false',
  
  // Product Review Feature
  PRODUCT_REVIEWS: process.env.REACT_APP_FEATURE_PRODUCT_REVIEWS !== 'false',
  
  // Analytics and Reporting
  ANALYTICS: process.env.REACT_APP_FEATURE_ANALYTICS !== 'false',
  
  // User Management
  USER_MANAGEMENT: process.env.REACT_APP_FEATURE_USER_MANAGEMENT !== 'false',

  // New Operating-System navigation + Command Centre (Dashboard Redesign, Phase 1)
  // When enabled: sidebar uses the 9-workspace structure and the authenticated
  //   landing page becomes the role-aware Command Centre (/app/home).
  // When disabled: the original flat "APPS" sidebar and /app/sales/dashboard land.
  // Toggle off in production with REACT_APP_FEATURE_NEW_NAV=false. Fully reversible.
  NEW_NAV: process.env.REACT_APP_FEATURE_NEW_NAV !== 'false', // default enabled

  // Refined navigation (admin audit P1-6, approved Oct 2026):
  //   - Customers + Inbox + Requests merge into one "Clients" workspace
  //   - the six "create" nav rows retire (every list page carries its own
  //     create button — verified before removal; the routes are untouched)
  //   - "Index" is labelled "Market Index"
  // Toggle off with REACT_APP_FEATURE_REFINED_NAV=false to restore the
  // previous grouping instantly. Fully reversible, nav-config only.
  REFINED_NAV: process.env.REACT_APP_FEATURE_REFINED_NAV !== 'false', // default enabled

  // Homepage Builder 2.0 — the visual editor (Website Editor phase 1).
  // The classic builder stays available at its original route regardless;
  // this flag only controls whether the new editor appears in the nav.
  HPB2: process.env.REACT_APP_FEATURE_HPB2 !== 'false', // default enabled

  // Legacy sales product routes (Catalogue Admin Tier 1, Task 1).
  // OFF (default): /app/sales/product-edit/:id redirects through the
  //   open-product resolver (card-linked units open the Product Workspace)
  //   and /app/sales/product-new redirects to catalogue Add Product. The
  //   legacy wizard stays mounted at /app/catalog/legacy/* for units that
  //   have no catalogue card yet — the resolver falls back there.
  // ON (REACT_APP_FEATURE_LEGACY_SALES_PRODUCT_ROUTES=true): the original
  //   components return to their original paths. Fully reversible.
  LEGACY_SALES_PRODUCT_ROUTES: process.env.REACT_APP_FEATURE_LEGACY_SALES_PRODUCT_ROUTES === 'true',
};

export default features; 